import { render } from "./EmptyState.vue?vue&type=template&id=620beb7f&scoped=true"
import script from "./EmptyState.vue?vue&type=script&lang=ts"
export * from "./EmptyState.vue?vue&type=script&lang=ts"

import "./EmptyState.vue?vue&type=style&index=0&id=620beb7f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-620beb7f"

export default script